<template>
  <div class="block">


    <el-timeline>
      <!--      <el-timeline-item-->
      <!--          :timestamp="regis_info.regis_time"-->
      <!--          placement="top">-->
      <!--        <el-card>-->
      <!--          <h4>首次注册</h4>-->
      <!--          <p>{{ regis_info.patient_name }} 提交于 {{ regis_info.regis_time }}</p>-->
      <!--        </el-card>-->
      <!--      </el-timeline-item>-->

      <el-timeline-item
          v-for="(item, index) in user_treat_his_trace"
          :key="index"
          :timestamp="item.stick_time"
          placement="top">
        <el-card  style="background-color: #6EC8FB">
          <h4>{{ item.病症 }} 方子数：{{ item.counts }}</h4>
          <p>诊所:{{ item.clinic_name }}, 医生:{{ item.dname }}, 开方时间: {{ item.real_st_time }}</p>
        </el-card>
      </el-timeline-item>
    </el-timeline>
  </div>

</template>

<script>
export default {
  name: "DataTracer",
  data() {
    return {
      user_treat_his_trace: null,
    };
  },
  mounted() {
    this.query_his()
  },
  methods: {
    query_his() {
      this.$http.post(process.env.VUE_APP_API_HOST + "/user_treat_his_trace", {"content-type": "application/json"}).then((res) => {
        this.user_treat_his_trace = res.data.data;
        this.regis_info = res.data.regis_info;
      })
    }
  }
}
</script>

<style scoped>

</style>
